<template>
 

</template>

<script>
// import '../assets/js/main.js'; 
// import '../assets/js/layout.js';   
export default {
  name: 'FooterPart',
 beforeMount(){
    var script = document.querySelector('script[src="../assets/js/vendor/smooth-scrollbar/smooth-scrollbar.min.js"]');
    if (script) {
      document.body.removeChild(script);
    }
    script = document.querySelector('script[src="../assets/js/component/app-menu-bar.js"]');
    if (script) {
      document.body.removeChild(script);
    }
    script = document.querySelector('script[src="../assets/js/switcher.js"]');
    if (script) {
      document.body.removeChild(script);
    }
    script = document.querySelector('script[src="../assets/js/vendor/flowbite.min.js"]');
    if (script) {
      document.body.removeChild(script);
    }
    script = document.querySelector('script[src="../assets/js/layout.js"]');
    if (script) {
      document.body.removeChild(script);
    }
    script = document.querySelector('script[src="../assets/js/main.js"]');
    if (script) {
      document.body.removeChild(script);
    }




 },
    mounted() { 
    

      
    if(!this.isScriptLoaded("../assets/js/vendor/smooth-scrollbar/smooth-scrollbar.min.js")){
            const plugin4 = document.createElement("script");
            plugin4.setAttribute("src","../assets/js/vendor/smooth-scrollbar/smooth-scrollbar.min.js");
            plugin4.async = false;
            document.body.appendChild(plugin4);
      }

  
      if(!this.isScriptLoaded("../assets/js/component/app-menu-bar.js")){
            const plugin2 = document.createElement("script");
            plugin2.setAttribute("src","../assets/js/component/app-menu-bar.js");
            plugin2.async = false;
            document.body.appendChild(plugin2);
      }
      if(!this.isScriptLoaded("../assets/js/switcher.js")){
            const plugin21 = document.createElement("script");
            plugin21.setAttribute("src","../assets/js/switcher.js");
            plugin21.async = false;
            document.body.appendChild(plugin21);
      }
      if(!this.isScriptLoaded("../assets/js/vendor/flowbite.min.js")){
            const plugin14 = document.createElement("script");
            plugin14.setAttribute("src","../assets/js/vendor/flowbite.min.js");
            plugin14.async = false;
            document.body.appendChild(plugin14);
      }


      if(!this.isScriptLoaded("../assets/js/layout.js")){
            const plugin = document.createElement("script");
            plugin.setAttribute("src","../assets/js/layout.js");
            plugin.async = false;
            document.body.appendChild(plugin);

      }
      
       if(!this.isScriptLoaded("../assets/js/main.js")){
            const plugin22 = document.createElement("script");
            plugin22.setAttribute("src","../assets/js/main.js");
            plugin22.async = true;
            document.body.appendChild(plugin22);
            document.getElementById("loader").remove();
      }
},
methods:{
      isScriptLoaded(src)
      {
          return Boolean(document.querySelector('script[src="' + src + '"]')); 
      },
    }

}
</script>
 
<style scoped lang="scss"> 
</style>
